import { Component, OnInit, Input } from "@angular/core";

export interface HowItWorksWidgetInfo {
  title: string;
  blurb: string;
  imgSrc: string;
  reversed?: boolean;
}

@Component({
    selector: "app-homepage-how-it-works-widget",
    templateUrl: "./homepage-how-it-works-widget.component.html",
    styleUrls: ["./homepage-how-it-works-widget.component.scss"],
    standalone: false
})
export class HomepageHowItWorksWidgetComponent implements OnInit {
  @Input() info: HowItWorksWidgetInfo;

  constructor() {}

  ngOnInit(): void {}
}
